import { useRef } from 'react';
import useInfoPopover from '../responsive/useInfoPopover';
import { useScrolledInto } from '../responsive/scroll';
import './MapTimelineComponent.css';
import MapScreenshot from '../Images/map_screenshot.png';
import AmbulanceGreen from '../Images/ambulance_green.png';
import AmbulanceBlank from '../Images/ambulance_blank.png';
import AmbulanceRed from '../Images/ambulance_red.png';
import ActionPanel from '../Images/action_pins.png';
import magnifyingGlassGlyph from '../Images/magnifying-glass-glyph.png';
import sunGlyph from '../Images/sun-glyph.png';
import AmbulanceBlue from '../Images/ambulance_blue-cross.png';
import BlueCar from '../Images/blue-car.png';
import RedCar from '../Images/red-car.png';
import DoNotEnter from '../Images/do_not_enter.png';
import Hazard from '../Images/hazard.png';
import SlowDown from '../Images/slow-down.png';
import LeftPanel from '../Images/left-panel-graphic.png';
import GreyArrow from '../Images/grey-arrow.png';

const MapComponent = () => {
    const sectionRef = useRef(null);
    // Road-sign pins drop in as the map scrolls into view (was scrollPosition > 21157)
    const showPins = useScrolledInto(sectionRef, 0.724);
    return (
        <div ref={sectionRef} className="map-viewport grid-parent map-layout">
            <div className="title map-title">Map</div>
            <div className="map-overlay grid-parent">
                <img id="map-screenshot-img" src={MapScreenshot} alt="Overhead Map of Manhattan"/>
                <div id="vehicle-panel-1" className="vehicle-panel grid-parent">
                    <img id="ambulance-green-1" className="ambulance-icon" src={AmbulanceGreen} alt="Ambulance with Green Cross"/>
                    <span id="vehicle-1-designation" className="vehicle-id">
                        <span className="pound-sign">#</span> <span className="vehicle-number">210Y</span>
                    </span>
                    <img id="ambulance-green-2" className="ambulance-icon" src={AmbulanceGreen} alt="Ambulance with Green Cross"/>
                    <span id="vehicle-2-designation" className="vehicle-id">
                        <span className="pound-sign">#</span> <span className="vehicle-number">3D27</span>
                    </span>
                    <img id="ambulance-green-3" className="ambulance-icon" src={AmbulanceGreen} alt="Ambulance with Green Cross"/>
                    <span id="vehicle-3-designation" className="vehicle-id">
                        <span className="pound-sign">#</span> <span className="vehicle-number">F480</span>
                    </span>
                </div>

                <div id="vehicle-panel-2" className="vehicle-panel grid-parent">
                    <img id="ambulance-blank" className="ambulance-icon" src={AmbulanceBlank} alt="Ambulance Silhouette"/>
                    <span id="vehicle-blank-designation" className="vehicle-id">
                        <span className="pound-sign">#</span> <span className="vehicle-number">4TA7</span>
                    </span>
                </div>

                <div className="designation-box">
                    #4TA7
                </div>

                <div id="ambulance-red-cross-img" className="ambulance-red-cross">
                    <img className="ambulance-icon" src={AmbulanceRed} alt="Ambulance with Red Cross" />
                </div>
                
                { showPins ? <img id="hazard-sign-img" src={Hazard} alt='Hazard road sign' /> : "" }
                { showPins ? <img id="do-not-enter-img" src={DoNotEnter} alt="Do Not Enter road sign" /> : "" }
                { showPins ? <img id="slow-down-map-img" src={SlowDown} alt="Slow Down road sign" /> : "" }
                { showPins ? <img id="slow-down-map-img-2" src={SlowDown} alt="Slow Down road sign" /> : "" }

                <div className="slow-panel">
                    <img id="slow-down-panel" src={LeftPanel} alt="Slow Down panel"/>
                </div>

                <div className="action-panel">
                    <img id="action-panel-img" src={ActionPanel} alt="Right side panel" />
                </div>

                <div className="search-box-map grid-parent">
                    <div className="input-field grid-parent">
                        <img className="magnifying-glass-glyph" src={magnifyingGlassGlyph} alt="Magnifying Glass" />
                        <span id="search-on-map">Search on map</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TimelinePanel = () => {
    const { active: currentPopoverElement, close, containerRef, bind } = useInfoPopover();

    return <div ref={containerRef} className="grid-parent timeline-layout">
        <div id="overlay-timeline" className="darken-overlay" onClick={close} style={currentPopoverElement ? null : { display: 'none' }}></div>
        <div className="time-display-timeline">
            <span className="time-span">8:15 AM</span>
            <span className="month-span">Oct 30</span>
            <span id="weather-img"><img id="sun-glyph" src={sunGlyph} alt="sun"/></span>
            <span className="temp-span">48°</span>
        </div>

        <div className="title timeline-title">Timeline</div>

        <div 
            id="zoom-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "zoom-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Zoom Controls:</span> lets dispatchers zoom
            in for detailed second-by-second view
            or zoom out to see the full call
            sequence
            <div className="zoom-straight-line"></div>
            <div id="zoom-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="region-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "region-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Region Filter:</span> lets the dispatcher
            view only the borough/region
            they are tracking
            <div className="region-straight-line"></div>
            <div id="region-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="live-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "live-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Live Toggle:</span> a simple on/off
            control for real-time mode.
            Allows dispatcher to freeze the
            timeline for review or instantly
            return to live operation
            <div className="live-straight-line"></div>
            <div id="live-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="timeline-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "timeline-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Timeline View:</span> real-time
            horizontal line that displays the
            movement and status of all
            responding units
            <div className="timeline-straight-line"></div>
            <div id="timeline-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="traffic-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "red-car-box" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Traffic Cards:</span> display real-time
            route details, congestion conditions
            and any delays affecting each
            responding vehicle
            <div className="traffic-straight-line"></div>
            <div id="traffic-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="unit-indicator-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "ambulance-blue-cross-img" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Unit Indicator:</span> each vehicle is
            tagged with a unique ID and
            priority color for instant
            recognition
            <div className="unit-indicator-straight-line"></div>
            <div id="unit-indicator-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="time-marker-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "vertical-lines" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Time Markers:</span> precise event
            timestamps
            <div className="time-marker-straight-line"></div>
            <div id="time-marker-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="incident-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "midtown" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Incident Points:</span> key destination
            locations are labeled directly on
            the timeline
            <div className="incident-straight-line"></div>
            <div id="incident-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>



        <span
            {...bind("zoom-head")}
            className="pill-button zoom-button"
        >
            Zoom +/-
        </span>
        <span
            {...bind("region-head")}
            className="pill-button manhattan-button"
            
        >
            Manhattan
        </span>
        <span
            {...bind("live-head")}
            className="pill-button live-button"
        >
            <span className="circle live-circle"></span><span id="live-text">Live</span>
        </span>
        <span
            {...bind("timeline-head")}
            className="pill-button timeline-button"
        >
            Timeline
        </span>

        <div id="parallel-lines"></div>
        <img id="grey-arrow" src={GreyArrow} alt="Grey arrow"/>
        <div
            {...bind("vertical-lines")}
        >
            <div id="red-pill" className="time-pill">8:17</div>
            <div id="orange-pill" className="time-pill">8:25</div>
        </div>

        <span id="upper-west" className="grey-text">Upper West Side</span>
        <span id="west-end" className="timeline-text">270 West End Ave</span>

        <span
            {...bind("midtown")}
            className="grey-text"
        >
            Midtown East
        </span>
        <span 
            id="grand-central" 
            className="timeline-text"
        >
            Grand Central Terminal
        </span>
        
        <div id="designation-1" className="time-pill">#2819</div>
        <div id="designation-2" className="time-pill">#ZB33</div>
        <div id="designation-3" className="time-pill">#15S3</div>
        <div id="ambulance-red-cross-img-2" className="ambulance-red-cross">
            <img className="ambulance-icon" src={AmbulanceRed} alt="Ambulance with Red Cross" />
        </div>
        <div id="ambulance-red-cross-img-3" className="ambulance-red-cross">
            <img className="ambulance-icon" src={AmbulanceRed} alt="Ambulance with Red Cross" />
        </div>
        <div
            {...bind("ambulance-blue-cross-img")}
            className="ambulance-blue-cross"
        >
            <img className="ambulance-icon" src={AmbulanceBlue} alt="Ambulance with Blue Cross" />
        </div>

        <div
            {...bind("red-car-box")}
            className="car-time-box"
        >
            <div className="car-img">
                <img id="red-car-1" className="red-car" src={RedCar} alt="Red Car Outline" />
            </div>
            <span className="time-text">5 min</span>
        </div>
        <div id="blue-car-box" className="car-time-box">
            <div className="car-img">
                <img id="blue-car-1" className="blue-car" src={BlueCar} alt="Blue Car Outline" />
            </div>
            <span className="time-text">Medium</span>
        </div>
    </div>
}

const DispatcherVideoComponent = () => {
    return <div class="dispatch-vid-viewport grid-parent dispatch-video-layout">
        <video
            id="dispatcher-video"
            className="full-page-video"
            autoPlay
            loop
            muted
            playsInline
        >
            <source src="https://pixay-website-assets.s3.us-east-1.amazonaws.com/videos/website_dispatcher_view_formatted.mp4" type="video/mp4" />
        </video>
        <div class="text-half">
            <div className="rt-title">Route & Traffic Monitor</div>
            <div class="rt-text">
                Real-time EMS routing with surrounding<br/>
                traffic behavior and flow
            </div>
        </div>
    </div>
}


const MapTimelineComponent = () => {
    return <div>
        <MapComponent />
        <DispatcherVideoComponent />
        <TimelinePanel />
    </div>
}

export default MapTimelineComponent;